<template>
  <v-checkbox
    :label="field.name"
    :rules="fieldRules"
    :model-value="checkboxValue"
    :hint="field.description"
    @update:modelValue="updateValue"></v-checkbox>
</template>

<script setup lang="ts">
import { IEntryFieldDTO } from '@/dtos';
import { rules } from '@/helpers';
import { ref, watch, computed } from 'vue';

const props = defineProps<{
  field: IEntryFieldDTO;
  modelValue?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', fieldId: string, value: string): void;
}>();

const field = props.field;

// ✅ Validation rules
const fieldRules = ref<((value: string) => true | string)[]>([]);

watch(
  () => field,
  () => {
    fieldRules.value = [];
    if (field.is_required) {
      fieldRules.value.push(rules.required);
    }
  },
  { immediate: true },
);

// ✅ Convert incoming string to boolean for the checkbox
const checkboxValue = computed({
  get: () => props.modelValue === 'true',
  set: (val: boolean) => {
    emit('update:modelValue', field.id, val ? 'true' : 'false');
  },
});

const updateValue = (value: boolean | null) => {
  emit('update:modelValue', field.id, value ? 'true' : 'false');
};
</script>
